<!-- @format -->

<ng-container *transloco="let t">
  <div class="container">
    <div class="row title-container sis-pb-xs sis-pt-md">
      <div class="col-12">
        <h1 sisAutofocus id="skip-link-target" tabindex="-1" class="fake-crumbs">
          @if (courseUnitRealisation || application || plan || courseUnit) {
            @if (application && firstMessage.conversationId === application.id) {
              <span>{{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.CONVERSATION_TITLE_PREFIX_APPLICATION") }}</span
              >:
              {{ application.code }}
            }
            @if (plan && firstMessage.conversationId === plan.id) {
              <span>{{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.CONVERSATION_TITLE_PREFIX_PLAN") }}</span
              >:
              {{ plan.name }}
            }
            @if (courseUnitRealisation && firstMessage.conversationId === courseUnitRealisation.id) {
              <span>{{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.CONVERSATION_TITLE_PREFIX_COURSE_UNIT_REALISATION") }}</span
              >: {{ courseUnitRealisation.nameSpecifier | localizedString }},
              {{ courseUnitRealisation.name | localizedString }}
              {{ courseUnitRealisation.activityPeriod | localDateRange }}
            }
            @if (courseUnit && firstMessage.conversationId === courseUnit.id) {
              <span>{{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.CONVERSATION_TITLE_PREFIX_COURSE_UNIT") }}</span
              >:
              {{ courseUnit.code }}
              {{ courseUnit.name | localizedString }}
            }
          }
          @if (!courseUnitRealisation && !application && !plan) {
            @if (allMessages && allMessages.length > 1) {
              <span>{{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.TITLE") }}</span>
            }
            @if (allMessages && allMessages.length === 1 && firstMessage.categoryType === "MESSAGE") {
              <span>
                {{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.TITLE_ONE_MESSAGE") }}
              </span>
            }
            @if (allMessages && allMessages.length === 1 && firstMessage.categoryType === "NOTIFICATION") {
              <span>
                {{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.TITLE_ONE_NOTIFICATION") }}
              </span>
            }
          }
        </h1>
      </div>
    </div>

    @if (allMessages) {
      <div>
        <div class="row g-0 sis-pb-sm conversation-details-information">
          <div class="col-md-8 d-flex justify-content-start">
            @if (messageCount === 1) {
              <span class="guidance"> {{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.NUMBER_OF_MESSAGES_TOTAL_ONE") }} &nbsp; </span>
            }
            @if (messageCount > 1) {
              <span class="guidance">
                {{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.NUMBER_OF_MESSAGES_TOTAL", { messageCount: messageCount }) }} &nbsp;
              </span>
            }
            @if (unreadMessageCount === 1) {
              <span class="guidance">
                {{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.NUMBER_OF_MESSAGES_UNREAD_TOTAL_ONE") }}
              </span>
            }
            @if (unreadMessageCount > 1) {
              <span class="guidance">
                {{
                  t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.NUMBER_OF_MESSAGES_UNREAD_TOTAL", {
                    unreadMessageCount: unreadMessageCount,
                  })
                }}
              </span>
            }
          </div>
          <div class="col-md-4 d-flex justify-content-lg-end" data-cy="message-conversation-actions">
            <sis-button size="sm" [hollow]="true" (clicked)="goBack()" data-cy="message-conversation-back-button">
              <sis-icon icon="back"></sis-icon>
              <span>{{ t("SIS_COMPONENTS.MESSENGER.MESSAGE_CONVERSATION.BACK_BUTTON_TITLE") }}</span>
            </sis-button>
            <sis-menu-button color="primary" [options]="menuOptions" [placeLeft]="true"></sis-menu-button>
          </div>
        </div>
      </div>
    }
    <ul class="message-list">
      @for (message of firstThreeMessages; track entityId($index, message)) {
        <li>
          <div class="message-top-border">
            <sis-message
              [message]="message"
              [isExpanded]="isExpanded(message.id)"
              (expandEvent)="onExpandEvent($event)"
              (transitionEvent)="onTransition($event)">
            </sis-message>
          </div>
        </li>
      }
      @for (message of restOfMessages; track entityId($index, message)) {
        <li>
          <div class="message-top-border">
            <sis-message
              [message]="message"
              [isExpanded]="isExpanded(message.id)"
              (expandEvent)="onExpandEvent($event)"
              (transitionEvent)="onTransition($event)">
            </sis-message>
          </div>
        </li>
      }
    </ul>
  </div>
</ng-container>
